angular.module('invoice')
    .controller('InvoiceAddTouchOnlyController', function ($scope, $rootScope, $uibModalInstance, data, Invoice, InvoiceConst) {
        this.$onInit = () => {
            this.form = {
                id: data,
                worker: null
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return Invoice.addTouchOnly(this.form).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast(InvoiceConst.eventUpdate)
                })
        }
    })
